import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './SideNav.css';

const SideNav = () => {
  const location = useLocation();
  
  const menuItems = [
    { id: 'vehicles', label: 'Vehicle List', icon: '🚗', path: '/' },
    { id: 'annotations', label: 'Annotations', icon: '📝', path: '/annotations' }
  ];

  const isActive = (path) => {
    return location.pathname === path || 
           (path === '/' && location.pathname === '/') ||
           (path !== '/' && location.pathname.startsWith(path));
  };

  return (
    <div className="side-nav">
      <div className="side-nav-header">
        <div className="nav-logo">
          <span className="logo-icon">⚡</span>
        </div>
      </div>
      
      <nav className="side-nav-menu">
        {menuItems.map(item => (
          <Link
            key={item.id}
            to={item.path}
            className={`side-nav-item ${isActive(item.path) ? 'active' : ''}`}
            title={item.label}
          >
            <span className="side-nav-icon">{item.icon}</span>
          </Link>
        ))}
      </nav>
      
      <div className="side-nav-footer">
        <button 
          className="logout-btn"
          onClick={() => {
            localStorage.removeItem('token');
            window.location.reload();
          }}
          title="Logout"
        >
          <span className="side-nav-icon">🚪</span>
        </button>
      </div>
      
      {/* Selected item description */}
      <div className="selected-item-description">
        {menuItems.find(item => isActive(item.path))?.label || 'Vehicle List'}
      </div>
    </div>
  );
};

export default SideNav;
